<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box"
    :mask-closable="false"
    :footer="null"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["1541"]') }}</h2>
      <div class="d-tip-con">
        <template v-if="isLeader">
          {{ $t('message["341"]') }}
        </template>
        <template v-else>
          {{ $t('message["340"]') }}
        </template>
      </div>
      <template>
        <div
          v-if="isLeader"
          class="limit-btn-box"
        >
          <a-button
            type="primary"
            @click="serviceupDia"
          >
            {{ $t('message["599"]') }}
          </a-button>
          <a-button
            class=""
            @click="TipDialogVisible=false"
          >
            {{ $t('message["1537"]') }}
          </a-button>
        </div>
        <div
          v-else
          class="limit-btn-box"
        >
          <a-button
            type="primary"
            @click="TipDialogVisible=false"
          >
            {{ $t('message["1597"]') }}
          </a-button>
        </div>
      </template>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    projectItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
    cId () {
      return this.projectItemData.cid
    },
    projectId () {
      return this.projectItemData.projectid
    },
    isLeader () {
      return this.projectItemData.roleInfo && this.projectItemData.roleInfo.system_role * 1 === 1
    }
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    serviceupDia () {
      this.$emit('serviceupDia')
      this.TipDialogVisible = false
    }
  }
}
</script>
